import { Link } from "react-router-dom";
import { heroData } from "@/mocks/home";

export default function Hero() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20professional%20security%20and%20safety%20concept%20with%20abstract%20geometric%20shield%20patterns%20overlapping%20warm%20amber%20and%20dark%20tones%2C%20subtle%20grid%20texture%2C%20modern%20minimalist%20style%2C%20clean%20professional%20atmosphere%2C%20corporate%20brand%20design%20with%20soft%20gradient%20overlay%2C%20high%20quality%20abstract%20wallpaper%2C%20elegant%20security%20industry%20aesthetic&width=1600&height=900&seq=hero-bg-anmaster&orientation=landscape"
          alt="安大师安全防护"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="animate-fade-in-up">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading mb-5 leading-tight">
            {heroData.headline}
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            {heroData.subheadline}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
            <Link
              to={heroData.ctaLink}
              className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3.5 rounded-md text-base font-medium transition-all duration-300 whitespace-nowrap"
            >
              {heroData.ctaText}
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to={heroData.secondaryCtaLink}
              className="border border-background-50/30 hover:border-background-50/60 text-background-50 px-8 py-3.5 rounded-md text-base font-medium transition-all duration-300 whitespace-nowrap"
            >
              {heroData.secondaryCtaText}
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-3xl mx-auto">
            {heroData.stats.map((stat, index) => (
              <div
                key={index}
                className="text-center animate-fade-in-up"
                style={{ animationDelay: `${0.2 + index * 0.1}s` }}
              >
                <div className="text-2xl md:text-3xl font-bold text-primary-400 font-heading mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-50/60">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-float">
        <i className="ri-arrow-down-s-line text-2xl text-background-50/40"></i>
      </div>
    </section>
  );
}